import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { session_id: sessionId });
        if (data.access_token) localStorage.setItem("access_token", data.access_token);
        // Clean fragment so future refreshes don't re-run this
        window.history.replaceState({}, document.title, window.location.pathname);
        await refresh();
        toast.success(`Welcome, ${data.name}`);
        navigate(data.role === "admin" ? "/admin" : "/account", { replace: true, state: { user: data } });
      } catch (err) {
        const d = err?.response?.data?.detail;
        toast.error(typeof d === "string" ? d : "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div data-testid="auth-callback-page" className="container-refined py-24 text-forest-700">
      Signing you in…
    </div>
  );
}
